// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                                           from 'firebase/functions';

// ===== Interfaces =====

import {
    IPostCollabDocCheckpointExportResult,
}                                           from '../interfaces';

const exportPostCollaborativeDocCheckpoint = async ({
    test,
    docId,
    checkpointId,
}: {
    test: boolean,
    docId: string,
    checkpointId: string,
}): Promise<IPostCollabDocCheckpointExportResult> => {
    const functions = getFunctions();
    const callable = httpsCallable<
        Record<string, boolean | string>,
        IPostCollabDocCheckpointExportResult
    >(
        functions,
        'exportPostCollaborativeDocCheckpoint',
    );
    return callable({
        test,
        docId,
        checkpointId,
    }).then((result) => result.data as IPostCollabDocCheckpointExportResult).catch((err) => {
        throw err;
    });
};

export default exportPostCollaborativeDocCheckpoint;
